function FragmentsListController(stateService, $uibModal) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    ctrl.sortType = 'id'; 
    ctrl.sortReverse = false; 
  };

  ctrl.$onChanges = changes => {

  };

  ctrl.toggleEditMode = ($event, fragment) => {
    $event.preventDefault();
    $event.stopPropagation();
    ctrl.editMode = true;
    ctrl.onToggle({
      $event: {
        editMode: true,
        fragment: fragment,
      },
    });
  };

  ctrl.openDeleteModal = async($event, fragment) => {
    $event.preventDefault();
    $event.stopPropagation();
    let modalInstance = $uibModal.open({

      component: 'deleteFragmentModal',
      backdrop: 'static',
      resolve: {
        workspaceId: function () {
          return ctrl.workspaceId;
        },
        fragment: function () {
          return fragment;
        },
      },
    });

    modalInstance.result.then(
      fragmentId => {
        // User pressed 'Yes' in the modal.
          ctrl.onDelete({
            $event: {
              fragmentId: fragmentId,
            },
          });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };
  
  ctrl.setSortType = column => {
    ctrl.sortType = column;
  };

  ctrl.setSortReverse = () => {
    ctrl.sortReverse = !ctrl.sortReverse;
  };
}

angular
  .module('pis-tool.module')
  .controller('FragmentsListController', FragmentsListController);